import React from 'react';
import { AvatarView } from './view';
import { styles } from './styles';

export class Avatar extends React.Component {
  render() {
    return <AvatarView {...this.props} styles={styles} />;
  }
}
